import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { CommonModalComponent } from '@shared/components/common-modal/common-modal.component';
import { ModalResponseEnum } from '@shared/enums/modal-response.enum';

@Component({
  selector: 'app-user-account-is-deactivated-warning',
  imports: [CommonModalComponent, MatButtonModule],
  templateUrl: './user-account-is-deactivated-warning.component.html',
  styleUrl: './user-account-is-deactivated-warning.component.scss',
})
export class UserAccountIsDeactivatedWarningComponent implements OnInit {
  private dialogRef = inject(
    MatDialogRef<UserAccountIsDeactivatedWarningComponent>,
  );

  ngOnInit(): void {
    this.dialogRef.afterClosed().subscribe({
      next: (response) => {
        if (
          !response?.['event'] ||
          response?.['event'] === ModalResponseEnum.CANCEL
        ) {
          window.location.reload();
        }
      },
    });
  }

  onCancel() {
    this.dialogRef.close({ event: ModalResponseEnum.CANCEL });
  }
}
